import { useContext } from 'react';
import { WorkflowEngineContext } from '../WorkflowEngine/workflowEngineReducer';
import PageEngine from './PageEngine';
import PageState from '../Shared/pageState';
import Stack from '@mui/material/Stack';

export default () => {
  const { state } = useContext(WorkflowEngineContext);

  return (
    <Stack spacing={2}>
      {state.pages.map((page: PageState) => (
        <PageEngine key={page.id} {...page} />
      ))}
    </Stack>
  );
};
